export const FIRST_STEP_FOR_SETTINGS = 1;
